import React, { useState } from 'react';
import { Table, Button, Modal, Input, Spin } from 'antd';
import EditSupportChatModuleTag from './EditSupportChatModuleTag';
import useGetSupportChatModuleTagsQuery from './queries/useGetSupportChatModuleTagsQuery';
import useDeleteSupportChatModuleTagMutation from './queries/useDeleteSupportChatModuleTagMutation';

const { confirm } = Modal;

const SupportChatModuleTagsTable = () => {
  const [showEditTag, setShowEditTag] = useState(false);
  const [editingTagId, setEditingTagId] = useState(null);
  const [editing, setEditing] = useState(false);
  const [searchText, setSearchText] = useState('');

  const { data, isLoading } = useGetSupportChatModuleTagsQuery();
  const deleteMutation = useDeleteSupportChatModuleTagMutation();

  // Ensure we always have an array
  const supportChatModuleTags = Array.isArray(data) ? data : [];

  const editTag = (tagId, isEditing = true) => {
    setEditingTagId(tagId);
    setEditing(isEditing);
    setShowEditTag(true);
  };

  const setEditMode = isVisible => {
    setShowEditTag(isVisible);
    if (!isVisible) {
      setEditingTagId(null);
      setEditing(false);
    }
  };

  const deleteTag = tagData => {
    deleteMutation.mutate(tagData);
  };

  const handleSearch = e => {
    setSearchText(e.target.value);
  };

  if (isLoading) {
    return <Spin size="large" />;
  }

  // Filter tags based on search text
  const filteredTags = supportChatModuleTags.filter(tag =>
    tag.name.toLowerCase().includes(searchText.toLowerCase())
  );
  const editingTag = supportChatModuleTags.find(tag => tag.id === editingTagId);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      width: 250,
      key: 'name',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      width: 600,
      key: 'description',
    },
    {
      title: 'Active',
      dataIndex: 'isActive',
      width: 100,
      key: 'isActive',
      render: isActive => (isActive ? 'Yes' : 'No'),
    },
    {
      title: 'Delete',
      dataIndex: 'deletedAt',
      width: 100,
      key: 'deletedAt',
      render: (k, v) => (
        <Button
          type="danger"
          icon="delete"
          onClick={() => {
            confirm({
              title: 'Are you sure you want to delete this tag?',
              content:
                'THIS ACTION CANNOT BE UNDONE! This will remove the tag from all conversations.',
              onOk: () => {
                deleteTag(v);
              },
              onCancel() {},
            });
          }}
        />
      ),
    },
    {
      title: 'Edit',
      dataIndex: 'updatedAt',
      width: 100,
      key: 'updatedAt',
      render: (k, v) => (
        <Button
          type="primary"
          icon="edit"
          onClick={() => editTag(v.id, true)}
        />
      ),
    },
  ];

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder="Search tags by name..."
          value={searchText}
          onChange={handleSearch}
          style={{ width: 300, marginRight: 16 }}
          allowClear
        />
        <Button type="primary" onClick={() => editTag(null, false)}>
          + Add a New Module Tag
        </Button>
      </div>
      <div style={{ height: 'calc(100vh - 180px)', overflow: 'auto' }}>
        <Table
          rowKey={tag => `supportChatModuleTag_${tag.id}`}
          dataSource={filteredTags}
          columns={columns}
          bordered
          scroll={{ x: 'max-content' }}
          pagination={false}
        />
      </div>
      {showEditTag ? (
        <EditSupportChatModuleTag
          tag={editingTag}
          visible={showEditTag}
          setEditMode={setEditMode}
          editing={editing}
        />
      ) : null}
    </>
  );
};

export default SupportChatModuleTagsTable;
